// This placeholder implementation positions a div with a green 
// background behind the specified bounds, and it logs to the console
// changes to both bounds and extent.
var ArcGISBackground = /** @class */ (function () {
    function ArcGISBackground() {
        this._container = null;
        this._placeholder = null;
    }
    ArcGISBackground.prototype.create = function (container) {
        this._container = container;
        this._placeholder = document.createElement("div");
        this._placeholder.style.position = 'absolute';
        this._placeholder.style.backgroundColor = "lightgreen";
        this._placeholder.style.top = '0';
        this._placeholder.style.left = '0';
        this._placeholder.style.bottom = '0';
        this._placeholder.style.right = '0';
        this._container.appendChild(this._placeholder);
    };
    ArcGISBackground.prototype.destroy = function () {
        if (this._container) {
            while (this._container.lastChild)
                this._container.removeChild(this._container.lastChild);
        }
    };
    ArcGISBackground.prototype.updateBounds = function (bounds) {
        if (this._container && this._placeholder) {
            console.info("ArcGISBackground updateBounds", bounds);
            this._placeholder.style.left = bounds[0] + 'px';
            this._placeholder.style.bottom = bounds[1] + 'px';
            this._placeholder.style.right = this._container.offsetWidth - bounds[2] - bounds[0] + 'px';
            this._placeholder.style.top = this._container.offsetHeight - bounds[3] - bounds[1] + 'px';
        }
    };
    ArcGISBackground.prototype.updateExtent = function (extent) {
        console.info("ArcGISBackground updateExtent", extent);
    };
    ArcGISBackground.prototype.updateProviderInfo = function (url, basemap, portalItemId, apiKey, token) {
        console.info("ArcGISBackground updateProviderInfo", url, basemap, portalItemId, apiKey.length > 0, token.length > 0);
    };
    return ArcGISBackground;
}());
export default ArcGISBackground;
